import React, {useState} from 'react'

import { Select } from 'antd'

import SeasonSeries from "@components/season/SeasonSeries"

import './styles/serial-files.scss';

const listSeasons = [
    {
        label: 'Сезон 1',
        value: 'Сезон 1'
    },
    {
        label: 'Сезон 2',
        value: 'Сезон 2'
    },
    {
        label: 'Сезон 3',
        value: 'Сезон 3'
    },
    {
        label: 'Сезон 4',
        value: 'Сезон 4'
    }
]

function SerialFiles() {
    const [seasons, setSeasons] = useState<unknown[]>([])

    const onChangeSeason = (val:any) => {
        setSeasons(val)
    }

    return(
        <div className="serial-files app-page">
            <div className={"serial-files__select-seasons"}>
                <label className={"form-group-label"} htmlFor={"SelectSeason"}>
                    Выбор сезона
                </label>
                <Select
                    id={"SelectSeason"}
                    className={"app-select"}
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Выберите сезон"
                    onChange={onChangeSeason}
                    options={listSeasons}
                ></Select>
            </div>

            <div className={'serial-files__seasons'}>
                {
                    seasons.map((season, index) => {
                        return (
                            <div className={"serial-files__season"}>
                                <h6 className={"serial-files__season__title"}>
                                    { season }
                                </h6>
                                <SeasonSeries key={index} />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SerialFiles